import { PAGE_URLS } from 'utils/constants';
import { getItemOrDefaultToValue, getPersonName } from '../../details';
import { displayTime, formatTimeDifference } from '../../time';
import {
  BASE_EVENT_STATUS,
  BASE_EVENT_DISTRIBUTION,
  BASE_INCIDENT_STATUS,
} from 'utils/constants/eventStatus';
import { riskColors } from 'utils/constants/risks';
import { getModeConfiguration } from 'components/Map/MapOptions/MapWithRegions';
import { LOCATION_MODE } from 'utils/constants/Map';
import { BASE_EVENT_CATEGORY } from 'utils/constants/eventCategory';

export const getLocation = (event, selected, handleEventPolygonClick) => {
  if (event.locations[0].point) {
    return {
      lat: event.locations[0].point.latitude,
      lng: event.locations[0].point.longitude,
    };
  } else if (event.locations[0].polygon) {
    //saves the first index of the array in firstPos
    const [firstPos] = event.locations[0].polygon.points;
    const completePolyPoints = [...event.locations[0].polygon.points];
    // push it to last index
    completePolyPoints.push(firstPos);
    const color = event.general.category === BASE_EVENT_CATEGORY.NEWS.value;
    const poly = {
      type: 'polygon',
      layer: 'events',
      color: color ? riskColors.NEWS : riskColors.OTHERS,
      isFilled: true,
      paths: completePolyPoints.map(m => ({
        lat: m.latitude,
        lng: m.longitude,
      })),
      strokeOpacity: selected ? 1 : 0,
      onPolygonClick: ({ id, pageName, onClickfitBounds }) =>
        typeof handleEventPolygonClick === 'function' &&
        handleEventPolygonClick({ id, pageName, onClickfitBounds }),
      ...getModeConfiguration(
        selected ? LOCATION_MODE.HIGH_DETAIL : LOCATION_MODE.LOW_DETAIL,
      ),
    };
    return poly;
  } else if (event.locations[0].ellipse) {
    const ellipse = {
      ...event.locations[0].ellipse,
      type: 'eclipse',
      layer: 'events',
      center: {
        lat: event.locations[0].ellipse.centre.latitude,
        lng: event.locations[0].ellipse.centre.longitude,
      },
      strokeOpacity: selected ? 1 : 0,
      rotationAngle: event.locations[0].ellipse.angle,
      color: riskColors.OTHERS,
      editable: false,
      draggable: false,
      strokeWeight: 4,
      onPolygonClick: ({ id, pageName, onClickfitBounds }) =>
        typeof handleEventPolygonClick === 'function' &&
        handleEventPolygonClick({ id, pageName, onClickfitBounds }),
    };
    return ellipse;
  }
  return {};
};
export const transform = (list, timeZone) => {
  return list
    .map(data => ({
      id: data.general.id,
      pageName: PAGE_URLS.EVENTS.link,
      archived: data.general.archived,
      hidden: getItemOrDefaultToValue(data.general, 'hidden', false),
      reportId: getItemOrDefaultToValue(data.general, 'eventId', '-'),
      categoryName: getItemOrDefaultToValue(data.general, 'category', '-'),
      type: getItemOrDefaultToValue(data.general, 'type', '-'),
      title: getItemOrDefaultToValue(data.general, 'title', '-'),
      lastUpdatedTime: displayTime({
        timestamp: getItemOrDefaultToValue(
          data.publishing,
          'lastUpdatedAt',
          '-',
        ),
        timeZone,
      }),
      creatorName: getPersonName(data.general.creator.general),
      elapsedTime: formatTimeDifference(
        getItemOrDefaultToValue(data.general, 'eventStartTime', '-'),
        getItemOrDefaultToValue(data.general, 'eventFinishTime'),
      ),
      published: data.publishing.currentStatus
        ? BASE_EVENT_STATUS[data.publishing.currentStatus].value
        : '',
      distribution: data.publishing.distribution
        ? BASE_EVENT_DISTRIBUTION[data.publishing.distribution].value
        : '',
      assignee:
        data.operational.assignedTo != null
          ? getPersonName(data.operational.assignedTo.general)
          : '-',
      assigneeId:
        data.operational.assignedTo != null
          ? getItemOrDefaultToValue(
              data.operational.assignedTo.general,
              'id',
              '-',
            )
          : '-',
      status: data.general.incidentStatus
        ? BASE_INCIDENT_STATUS[data.general.incidentStatus].value
        : '-',
      location: getLocation(data),
      eventStartTime: getItemOrDefaultToValue(
        data.general,
        'eventStartTime',
        '-',
      ),
    }))
    .sort((data1, data2) => {
      const response =
        new Date(data2.eventStartTime) - new Date(data1.eventStartTime);
      return response;
    });
};
